import React from "react";

// Ornate filigree corner (top-left orientation by default)
function Corner({ className = "" }) {
  return (
    <svg viewBox="0 0 44 44" width="18" height="18" fill="none"
      className={`text-gold pointer-events-none ${className}`} aria-hidden="true">
      <path d="M3 43 L3 15 Q3 3 15 3 L43 3" stroke="currentColor" strokeWidth="1.6" opacity="1" />
      <path d="M9 43 L9 17 Q9 9 17 9 L43 9" stroke="currentColor" strokeWidth="0.9" opacity="0.6" />
      <path d="M6 22 Q10 12 20 8" stroke="currentColor" strokeWidth="0.9" opacity="0.7" />
      <circle cx="7" cy="7" r="1.8" fill="currentColor" />
    </svg>
  );
}

export function OrnateFrame({ className = "", children, hover = false, testId }) {
  return (
    <div className={`ht-panel ${hover ? "ht-panel-hover" : ""} ${className}`} data-testid={testId}>
      <Corner className="absolute top-1.5 left-1.5" />
      <Corner className="absolute top-1.5 right-1.5 rotate-90" />
      <Corner className="absolute bottom-1.5 right-1.5 rotate-180" />
      <Corner className="absolute bottom-1.5 left-1.5 -rotate-90" />
      {children}
    </div>
  );
}

export function Flourish({ className = "" }) {
  return (
    <div className={`ht-flourish ${className}`}>
      <svg viewBox="0 0 24 12" width="20" height="10" fill="none" aria-hidden="true">
        <path d="M2 6 L9 6 M15 6 L22 6" stroke="currentColor" strokeWidth="1" />
        <path d="M12 1 L15 6 L12 11 L9 6 Z" fill="currentColor" />
      </svg>
    </div>
  );
}

// Standard tab header: eyebrow label + ornate title + optional right-side action
export function TabHeader({ label, title, children, testId }) {
  return (
    <div className="flex items-end justify-between flex-wrap gap-4 mb-2" data-testid={testId}>
      <div>
        {label && <div className="ht-eyebrow mb-2.5">{label}</div>}
        <h2 className="ht-title text-3xl sm:text-4xl">{title}</h2>
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
